import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-imap-detail',
  templateUrl: './imap-detail.component.html'
})
export class ImapDetailComponent extends BaseComponent {
  imap:any;
  testResult:any;
  changePassword:boolean = false;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/mail/incoming/mailboxes/${id}`).subscribe(
            data => {
              this.imap = data as any;
              this.testConnection();
            }
          );
        }
      });
  }

  createNew() {
    this.imap = {
      port: 993,
      protocol: 'imaps',
      enabled: true,
      folder: 'INBOX',
      blockAllowType: 'NA',
      authenticationType: 'BASIC'
    };
  }

  save() {
    if (!this.imap.id) {
      this.http.post(`${this.env.e.url}/mail/incoming/mailboxes`, this.imap)
        .subscribe(
          data => {
            this.imap = data;
            this.alertService.info(`Created ${this.imap.email}`);
            this.testConnection();
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/mail/incoming/mailboxes/${this.imap.id}`, this.imap)
        .subscribe(
          data => {
            this.imap = data;
            this.alertService.info(`Updated settings`);
            this.testConnection();
          }
        );
    }
    this.changePassword = false;
  }

  deleteMailbox() {
    this.http.delete(`${this.env.e.url}/mail/incoming/mailboxes/${this.imap.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted Mailbox ${this.imap.email}`);
          this.router.navigate(["/mail/imap"]);
        }
      );
  }

  testConnection() {
    this.testResult = null;
    this.http.get(`${this.env.e.url}/mail/incoming/mailboxes/${this.imap.id}/test`).subscribe(
      data => {
        this.testResult = data as any;
      }
    );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
